import { IsEnum, IsNotEmpty, IsOptional, IsString } from '@pristine-ts/class-validator';
import { CalculationKeynameEnum } from '../../enums/calculations/calculation-keyname.enum';
import { translationBaseKey } from '../../decorators/translation-base-key.decorator';
import { advancedFormControl, FieldType, FormControlTypeEnum } from '@magieno/common';

@translationBaseKey('calculation-creation-options')
export class CalculationCreationOptions {
  @advancedFormControl({
    type: FormControlTypeEnum.Hidden,
  })
  @IsString()
  @IsEnum(CalculationKeynameEnum)
  @IsNotEmpty()
  calculationKeyname: CalculationKeynameEnum;

  @advancedFormControl({
    type: FormControlTypeEnum.Input,
    fieldType: FieldType.String,
  })
  @IsString()
  @IsNotEmpty()
  title: string;

  @IsOptional()
  @IsString()
  mandateId?: string;

  @IsOptional()
  @IsString()
  customerId?: string;

  @IsOptional()
  @IsString()
  createFromCalculationId?: string;
}
